import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Header, Segment, Container, Button, Form } from 'semantic-ui-react';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import html2canvas from 'html2canvas';
import { StaffInfoBlock, Commons } from 'components';
import UserBarcodeModal from 'components/StaffInfo/Modal/UserBarcode';
import CommonModal from 'components/StaffManagement/Modal/CommonModal';
import * as cmAction from 'actions/commons';
import * as cpAction from 'actions/company';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';
import base64 from 'helpers/base64';

moment.tz.setDefault('Asia/Seoul');

const propTypes = {};

const defaultProps = {};

class StaffInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        signid: '',
        password: '',
        password2: '',
        passwordreset: 'Y',
        name: '',
        email: '',
        phone: '',
        position: '',
        comidnum: '',
        level: 0,
        group: '',
        rankposition: 0,
        depth: {
          one: 0,
          two: 0,
          three: 0
        },
        dormant: undefined,
        historyList: []
      },
      isLoading: true,
      confirmShow: false,
      confirmText: {
        btnText: '',
        header: '',
        text: null
      },
      staffDivisionInfo: null,
      confirmFn: null,
      groupAuth: cm.authGroupSet('employee'),
      mealcGorupAuth: cm.authGroupSet('meal-group'),
      accountModal: {
        open: false,
        dimmer: true
      },
      isPrintBarcode: null,
      barcode: '',
      barcodeModal: {
        open: false
      },
      btns: {
        sBtn: [],
        wBtn: []
      }
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);
    const { groupAuth } = this.state;
    const { company } = this.props;
    const { user } = company.data;
    const { isPrintBarcode } = user.company;
    const url = window.location.pathname;

    if (url === '/main/staffInfo/join/new') {
      if (!groupAuth.all && !groupAuth.create) {
        toastr('top-right', 'warning', '사용자 추가 권한이 없습니다.');
        this.context.router.history.push('/service/landing');
      }
    } else if (!groupAuth.all && !groupAuth.update) {
      toastr('top-right', 'warning', '사용자 추가 권한이 없습니다.');
      this.context.router.history.push('/service/landing');
    }

    this.staffSel();
    this.setState({ isPrintBarcode });
  }

  componentDidMount() {
    const { type } = this.props.match.params;
    if (type === 'join') {
      cm.mainTitle('사용자 추가');
    } else if (type === 'dormant') {
      cm.mainTitle('휴면 사용자 정보 수정');
    } else {
      cm.mainTitle('사용자 정보 수정');
    }
  }

  componentDidUpdate() {
    // semantic confirm button css change
    if (this.state.confirmShow) {
      $('.confirm-model > .actions')
        .children()
        .eq(0)
        .attr('class', 'ui grey inverted button cancel');
      $('.confirm-model > .actions')
        .children()
        .eq(1)
        .attr('class', 'ui red button ok');
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const result = false;
    if (nextState !== this.state) {
      return true;
    }
    return false;
  }

  // 사용자별 부서 조회
  setUserDivision = () => {
    const { info } = this.state;

    this.setState({
      staffDivisionInfo: cm.staffDivision(info.orgcode)
    });
  };

  // 사용자 정보 조회
  staffSel = async () => {
    const { cmAPI } = this.props;
    const { type, id } = this.props.match.params;
    const params = {
      id
    };
    try {
      // await this.divisionSel();
      await this.sikdaeGroup();
      await this.PositionSel();

      if (type === 'det' || type === 'dormant') {
        if (type === 'det') {
          await cmAPI.staffSel(params);
        } else {
          await cmAPI.dormantStaff(params);
        }

        const { staffList, dormant } = this.props;
        const data = type === 'det' ? staffList.data.user : dormant.data.dormantUser;

        const signId = data.signid ? data.signid : data.signId;

        const info = {
          id: data.id,
          signid: signId,
          password: '',
          password2: '',
          passwordreset: 'Y',
          name: data.name ? data.name : data.name,
          email: data.email && data.email.value ? data.email.value : '',
          emailAuth: data.email && data.email.auth ? data.email.auth : false,
          phone: data.phone && data.phone.value ? data.phone.value : '',
          phoneAuth: data.phone && data.phone.auth ? data.phone.auth : false,
          isCertification: data.isCertification ? data.isCertification : false,
          comidnum: data.comidnum ? data.comidnum : '',
          position: data.position ? data.position : '',
          level: data.level,
          group: data.group && data.group.idx,
          rankposition: data.rankposition ? data.rankposition.text : '',
          orgcodelist: data.orgcodelist ? data.orgcodelist : null,
          orgcode: data.orgcodelist ? data.orgcodelist[data.orgcodelist.length - 1] : null,
          auth: data.auth,
          grade: data.grade,
          status: data.status,
          historyList: data.historyList,
          dormant: type === 'dormant' ? { target: data.dormant, expectedDate: data.dormantDate } : data.dormant
        };
        info.status = data.status;
        this.setState({ info });
        this.historyBtn(info);
        this.setUserDivision();
      }
      this.setState({ isLoading: false });
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
        this.context.router.history.push('/main/staffManagement');
      }

      console.log('###### staffSel error : ', e);
    } finally {
    }
  };

  // 식대 그룹 조회
  sikdaeGroup = async () => {
    const { cmAPI } = this.props;
    const params = { viewType: 'all' };

    try {
      await cmAPI.sikdaeGroupList(params);
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### sikdaeGroup : ', e);
    } finally {
    }
  };

  // 직위 조회

  PositionSel = async () => {
    try {
      const { cpAPI } = this.props;
      await cpAPI.positionSel();
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }
      console.log('###### PositionSel error : ', e);
    } finally {
    }
  };

  handleEvent = async (type, data) => {
    const { cmAPI } = this.props;

    this.setState({
      info: update(this.state.info, { [type]: { $set: data } })
    });
  };

  validation = () => {
    const { info, mealcGorupAuth } = this.state;
    const { type, id } = this.props.match.params;
    const { position, level, groupIdx, depth, auth, vitality } = this.props;

    const params = {
      signid: info.signid,
      name: info.name ? info.name : null,
      email: info.email ? info.email : null,
      phone: info.phone ? info.phone : null,
      level: vitality && vitality.value ? vitality.value : info.level ? info.level : 1,
      groupidx: groupIdx && groupIdx.value ? groupIdx.value : info.group,
      orgCode: depth && depth.value ? depth.value : null,
      rankposition: info.rankposition ? info.rankposition : null,
      position: info.position ? info.position : null,
      comidnum: info.comidnum ? info.comidnum : null,
      passwordreset: info.passwordreset === 'Y' ? 'N' : 'Y'
    };

    if (type === 'join') {
      params.password = info.password;
    } else if (type === 'det') {
      params.id = id;
    }
    const result = false;

    if (!info.signid) {
      toastr('top-right', 'warning', '아이디를 입력하세요.');
      return result;
    }
    if (/^([0-9a-zA-Z-_@.+])*$/.test(info.signid) === false) {
      toastr('top-right', 'warning', '아이디는 영문, 숫자, +-_@. 만 가능합니다.');
      return result;
    }
    if (info.signid.length < 6 || info.signid.length > 40) {
      toastr('top-right', 'warning', '아이디는 6자 이상 40자 이하로 입력해주세요.');
      return result;
    }
    if (type === 'join' && !info.password) {
      toastr('top-right', 'warning', '비밀번호를 입력하세요.');
      return result;
    }
    if (type === 'join' && info.password.length < 4) {
      toastr('top-right', 'warning', '비밀번호는 4자 이상 입력하세요.');
      return result;
    }
    if (type === 'join' && !info.password2) {
      toastr('top-right', 'warning', '비밀번호를 입력하세요.');
      return result;
    }

    if (type === 'join' && !(info.password === info.password2)) {
      toastr('top-right', 'warning', '비밀번호가 일치하지 않습니다.');
      return result;
    }

    if (!info.name) {
      toastr('top-right', 'warning', '이름을 입력하세요.');
      return result;
    }
    if (info.name.length > 30) {
      toastr('top-right', 'warning', '이름은 30자까지 입력 가능합니다.');
      return result;
    }

    if (info.email && !cm.validateEmail(info.email)) {
      toastr('top-right', 'warning', '이메일 형식이 아닙니다.');
      return result;
    }

    if (info.phone && !cm.validatePhone2(info.phone)) {
      toastr('top-right', 'warning', '휴대전화번호 형식이 아닙니다.');
      return result;
    }

    if (!params.level) {
      toastr('top-right', 'warning', '사용자 상태를 선택하세요.');
      return result;
    }

    if (!params.groupidx) {
      if (mealcGorupAuth.all || mealcGorupAuth.assign) {
        toastr('top-right', 'warning', '식대 그룹을 선택하세요.');
        return result;
      }
    }

    if (!depth || !depth.value) {
      toastr('top-right', 'warning', '부서를 선택하세요.');
      return result;
    } else {
      const info = storage.get('info');

      if (info.auth.type === 'DIVISION') {
        const authResult = cm.authDivisionCheck(info.auth, depth.value);

        if (authResult) {
          toastr('top-right', 'warning', '해당 부서권한이 없습니다.');
          return result;
        }
      }
    }

    if (params.position && params.position.length > 20) {
      toastr('top-right', 'warning', '직책을 20자 이하로 입력해주세요.');
      return result;
    }

    if (params.comidnum && params.comidnum.length > 15) {
      toastr('top-right', 'warning', '사원번호를 15자 이하로 입력해주세요.');
      return result;
    }

    return params;
  };

  // 사용자 등록
  staffInfoAct = async () => {
    const params = this.validation();

    if (params.password) {
      params.password = base64.encode(params.password);
    }
    const { type } = this.props.match.params;
    let method = '';

    if (type === 'join') {
      method = 'post';
    } else if (type === 'det') {
      method = 'put';
    }

    if (params !== false) {
      const { cpAPI } = this.props;
      try {
        if (type !== 'dormant') {
          await cpAPI.staffInfoAct(method, params);
          this.context.router.history.push('/main/staffManagement');
        } else {
          // Button Componet에서 버튼 삭제
          this.context.router.history.push('/main/dormantStaffManagement');
        }
      } catch (e) {
        const { response } = e;

        if (response) {
          toastr('top-right', 'error', response.data.message);
        }

        console.log('###### staffInfoAdd error : ', e);
      } finally {
      }
    }
  };

  // 강제 로그아웃
  logout = async () => {
    const { cpAPI } = this.props;
    const { id } = this.props.match.params;

    try {
      const params = null;

      await cpAPI.logOut(id, params);

      const { logout } = this.props;

      if (logout && logout.data) {
        const { tokens } = logout.data;

        tokens.forEach(async (data) => {
          await cpAPI.logOutStepTwo({ token: data });
        });

        toastr('top-right', 'success', '강제로그아웃 되었습니다.');
      }
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### staffInfoAdd error : ', e);
    } finally {
      this.setState({ confirmShow: false });
    }
  };

  // 사용자 사
  staffInfoDel = async () => {
    const { type, id } = this.props.match.params;
    const { cpAPI } = this.props;

    const params = {
      id
    };

    try {
      await cpAPI.staffDel(params);
      const { staffDel } = this.props;
      this.context.router.history.push('/main/staffManagement');
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### staffInfoDel error : ', e);
    } finally {
    }
    this.setState({ confirmShow: false });
  };

  // 사용자 비밀번호 초기회
  changePassword = async (pwd, rePwd) => {
    try {
      if (!pwd) {
        toastr('top-right', 'warning', '초기화 비밀번호를 입력하세요.');
        return;
      }
      if (pwd !== rePwd) {
        toastr('top-right', 'warning', '재입력한 비밀번호가 일치하지 않습니다.');
        return;
      }

      const { cpAPI } = this.props;
      const { id } = this.props.match.params;
      const params = {
        id,
        password: base64.encode(pwd)
      };

      await cpAPI.staffPwdChange(params);
      toastr('top-right', 'success', '비밀번호가 초기화 되었습니다.');
      this.setState({
        modal: {
          open: false
        }
      });
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### changePassword error : ', e);
    } finally {
    }
  };

  // 페이지 이동
  movePage = (fnType) => {
    const { type } = this.props.match.params;
    if (fnType === 'close') {
      type !== 'dormant'
        ? this.context.router.history.push('/main/staffManagement')
        : this.context.router.history.push('/main/dormantStaffManagement');
    }
  };

  // confirm 팝업
  confirmShow = (isOpen, type) => {
    const style = {
      text: { color: 'red' }
    };

    if (type === 'resign') {
      this.setState({
        confirmText: {
          btnText: '완료',
          header: '사용자 퇴사처리',
          text: (
            <div className="content">
              <span>
                * 퇴사처리 후 식대
                <span style={style.text}> 지급 및 사용이 즉시 중지 </span>
                됩니다.
              </span>
              <br />
              <span>
                * My포인트 환불에 대해선
                <span style={style.text}> 식권대장에 문의</span>
                해주셔야 합니다.
              </span>
              <br />
              <span>
                {' '}
                * 계정 탈퇴 후<span style={style.text}> 복구가 불가능</span>
                하오니, 신중히 처리해주시길 바랍니다.
              </span>
            </div>
          )
        },
        confirmFn: this.staffInfoDel
      });
    } else if (type === 'logout') {
      this.setState({
        confirmText: {
          btnText: '완료',
          header: '강제 로그아웃',
          text: (
            <div className="content">
              <span>동일한 아이디(계정)으로 로그인되어 있는 여러기기의 계정을 강제 로그아웃 처리합니다.</span>
            </div>
          )
        },
        confirmFn: this.logout
      });
    }
    this.setState({ confirmShow: isOpen });
  };

  // 모달팝업
  modal = (type, size) => {
    const data = {
      open: type,
      size,
      onOff: this.modal,
      changePassword: this.changePassword
    };

    this.setState({
      modal: data
    });
  };

  // 권한 및 범위 변경하기
  authChange = () => {
    const { info } = this.state;
    const { cmAPI } = this.props;

    if (info.auth) {
      cmAPI.authInfo({
        type: 'authInfo',
        name: 'value',
        value: info
      });

      this.context.router.history.push('/main/accountManagement', {
        id: info.id
      });
    }
  };

  // 바코드 출력 팝업
  barcodeModal = (type) => {
    if (type === '취소') {
      this.setState({
        barcodeModal: {
          open: false
        }
      });
    } else {
      this.setState({
        barcodeModal: {
          open: true
        }
      });
      this.onCreateBarcode();
    }
  };

  // 바코드 생성
  onCreateBarcode = async () => {
    const { info } = this.state;
    const { cmAPI } = this.props;
    const params = {
      userId: info.id
    };
    await cmAPI.staffBarcode(params);

    const { staffBarcodeInfo } = this.props;
    if (staffBarcodeInfo) {
      const { data } = staffBarcodeInfo;
      await this.setState({ barcode: data.barcode });
    }
  };

  // 바코드 이미지 다운로드
  onDownloadBarcode = () => {
    const { info } = this.state;
    const print = document.getElementById('printBarcode');

    html2canvas(print).then((canvas) => {
      const a = document.createElement('a');

      a.href = canvas.toDataURL('image/png');
      a.download = `barcode_${info.signid}.png`;
      a.click();
    });
  };

  accountModal = (result, header) => {
    const isShow = typeof result === 'boolean' ? result : false;
    this.setState({
      accountModal: {
        dimmer: isShow,
        open: isShow,

        header: typeof header === 'string' ? header : null
      }
    });
  };

  accountMod = async (type, reserveDate) => {
    const { info } = this.state;
    let value = null;
    if (type === 'withdraw') {
      value = -5;
    } // 계정 탈퇴
    else if (type === 'pause') {
      value = -1;
    } // 계정 일시정지
    else if (type === 'pauseCancel') {
      value = 1;
    } // 계정 일시정지해제

    const params = {
      type: {
        key: type,
        value
      },
      user: {
        id: [info.id]
      },
      reserveDate
    };
    try {
      const { cpAPI } = this.props;
      await cpAPI.staffBulkMod(params);
      await this.accountModal(false, null);
      this.setState({ isLoading: true });
      if (type === 'withdraw') {
        setTimeout(() => {
          if (reserveDate) {
            this.staffSel();
            this.setState({ isLoading: false });
          } else {
            this.context.router.history.push('/main/staffManagement');
          }
        }, 1500);
      } else {
        setTimeout(() => {
          this.staffSel();
          this.setState({ isLoading: false });
        }, 1500);
      }
    } catch (error) {
      const { response } = error;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      this.setState({ isLoading: false });
      console.log('###### staffBulkMod error : ', error);
    }
  };

  // 정보 변경 내역 예약 취소
  cancelReserve = async (idx) => {
    const { cpAPI } = this.props;
    this.setState({ isLoading: true });
    try {
      await cpAPI.cancelReserveDel(idx);
      setTimeout(() => {
        this.staffSel();
        this.setState({ isLoading: false });
      }, 1500);
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      this.setState({ isLoading: false });
      console.log('###### changeInfoSel error : ', e);
    }
  };

  historyBtn = (info) => {
    if (info) {
      const { historyList } = info;
      const result = {
        sBtn: [],
        wBtn: []
      };
      const infoHistoryIdx = 0;
      if (!historyList || !historyList.length) {
        this.setState({ btns: result });
      } else {
        historyList.forEach((item) => {
          if (item.status === 'READY') {
            let key = '';
            const text = [];
            switch (item.type) {
              case 'ACTIVE':
                return result;
              case 'INACTIVE':
                key = 'sBtn';
                text.push('일시정지 예약 취소');
                text.push('일시정지로 변경 예약되어 있습니다.');
                break;
              case 'WITHDRAW':
                key = 'wBtn';
                text.push('탈퇴 예약 취소');
                text.push('탈퇴 예약되어 있습니다.');
                break;
              default:
                break;
            }
            // result = [];
            result[key].push(
              <Button
                className="pwd-init-btn"
                inverted
                color="black"
                onClick={(e) => this.cancelReserve(item.infoHistoryIdx)}
              >
                {text[0]}
              </Button>
            );
            result[key].push(
              <Form.Group inline className="field">
                <label />
                <Form.Field>
                  <span style={{ color: 'red' }}>{`* ${cm.yyyyMMddhhmm(item.date)} ${text[1]}`}</span>
                </Form.Field>
              </Form.Group>
            );
          }
          this.setState({ btns: result });
        });
      }
    }
  };

  render() {
    const {
      info,
      staffDivisionInfo,
      isLoading,
      confirmShow,
      confirmText,
      modal,
      confirmFn,
      groupAuth,
      accountModal,
      barcodeModal,
      btns,
      barcode,
      isPrintBarcode
    } = this.state;
    const { sikdaeGroup, staffDivision } = this.props;
    const { type, id } = this.props.match.params;
    const ai = {
      data: {
        sikdaeGroup,
        staffDivision,
        btns
      }
    };
    const button = {
      fn: {
        staffInfoAct: this.staffInfoAct,
        movePage: this.movePage,
        confirmShow: this.confirmShow,
        staffInfoDel: this.staffInfoDel,
        authChange: this.authChange,
        accountModal: this.accountModal,
        confirmFn
      },
      data: {
        confirmShow,
        confirmText,
        groupAuth
      },
      modal: { onOff: this.modal }
    };
    const staffCheckedData = [
      {
        id: info.id,
        name: info.name,
        signid: info.signid
      }
    ];
    return (
      <main>
        <div className="search-box si">
          <Container fluid>
            {isLoading ? (
              <Commons.LoadingBar />
            ) : (
              <div>
                {type === 'join' ? null : (
                  <StaffInfoBlock.Buttons
                    position="top"
                    fn={button.fn}
                    data={button.data}
                    grade={type !== 'dormant' ? info.grade : info.status}
                    history={info.historyList}
                    modal={button.modal}
                    type={type}
                  />
                )}

                <Segment vertical className="title top">
                  <Header as="h2">개인정보</Header>
                </Segment>
                <Segment vertical className="personal">
                  <StaffInfoBlock.IndividualInfo handleEvent={this.handleEvent} type={type} info={info} />
                </Segment>
                <Segment vertical className="title">
                  <Header as="h2">부가정보</Header>
                </Segment>
                <Segment vertical>
                  <StaffInfoBlock.AdditionalInfo
                    handleEvent={this.handleEvent}
                    accountModal={this.accountModal}
                    barcodeModal={this.barcodeModal}
                    cancelReserve={this.cancelReserve}
                    isPrintBarcode={isPrintBarcode}
                    data={ai.data}
                    info={info}
                    type={type}
                  />
                </Segment>
                <Segment vertical>
                  <StaffInfoBlock.Buttons position="bottom" fn={button.fn} auth={info.auth} type={type} />
                </Segment>
              </div>
            )}
            {modal ? (
              <StaffInfoBlock.ChangePWD
                size={modal.size ? modal.size : null}
                open={modal.open}
                closeFn={modal.onOff}
                okFn={modal.changePassword}
              />
            ) : null}
          </Container>
          <CommonModal
            modal={{
              dimmer: accountModal.dimmer,
              size: 'small',
              open: accountModal.open,
              header: accountModal.header,
              close: this.accountModal
            }}
            data={{ staffCheckedData }}
            fn={{
              bulkCompletionBtn: this.accountMod,
              cancelReserve: this.cancelReserve
            }}
          />
          <UserBarcodeModal
            modalFn={{
              open: barcodeModal.open,
              close: this.barcodeModal,
              download: this.onDownloadBarcode
            }}
            data={{
              barcode,
              name: info.name,
              group: staffDivisionInfo
            }}
          />
        </div>
      </main>
    );
  }
}

StaffInfo.contextTypes = {
  router: PropTypes.object.isRequired
};

StaffInfo.propTypes = propTypes;
StaffInfo.defaultProps = defaultProps;

StaffInfo = connect(
  (state) => ({
    sikdaeGroup: state.commons.sikdaeGroup,
    staffDivision: state.commons.staffDivision,
    policyIdx: state.commons.policy,
    groupIdx: state.commons.group,
    depth: state.commons.depth,
    staffJoin: state.commons.staffJoin,
    auth: state.commons.auth,
    company: state.auth.company,
    vitality: state.commons.vitality,
    position: state.commons.position,
    staffList: state.commons.staff,
    staffDel: state.company.staffDel,
    positionList: state.company.position,
    logout: state.company.logout,
    staffBarcodeInfo: state.commons.staffBarcodeInfo,
    dormant: state.commons.dormant
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cmAction.SikdaeGroupList,
        handleEvent: cmAction.ReduxDataSet,
        staffSel: cmAction.StaffSel,
        staffBarcode: cmAction.StaffBarcode,
        authInfo: cmAction.ReduxDataSet,
        dormantStaff: cmAction.dormantStaff
      },
      dispatch
    ),

    cpAPI: bindActionCreators(
      {
        positionSel: cpAction.PositionSel,
        staffInfoAct: cpAction.StaffAct,
        staffDel: cpAction.StaffDel,
        staffPwdChange: cpAction.StaffPwdChange,
        logOut: cpAction.Logout,
        logOutStepTwo: cpAction.LogoutStepTwo,
        staffBulkMod: cpAction.StaffBulkMod,
        cancelReserveDel: cpAction.CancelReserve
      },
      dispatch
    )
  })
)(StaffInfo);

export default StaffInfo;
